import _styled, { default as _styled2, default as _styled3, default as _styled4, default as _styled5, default as _styled6, default as _styled7, default as _styled8, default as _styled9, default as _styled10, default as _styled11, default as _styled12 } from "styled-components";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { useVisibilityObserver } from '@noths/polaris-client-react-hooks';
import { getAnchorElementFromEvent } from '@noths/polaris-client-utils';
import { Banner } from "../../elements/Banner/Banner";
import { FloatingBannerImage } from "../../elements/Banner/FloatingBannerImage/FloatingBannerImage";
import { Heading } from "../../internal/Heading/Heading";
import * as styles from "./HeroBanner.styles";
import { SolidButton, SolidButtonLink } from "../../..";
var HeadingInner = function HeadingInner(_ref) {
  var children = _ref.children,
    hasUnderline = _ref.hasUnderline;
  return /*#__PURE__*/React.createElement(_StyledSpan, {
    $_css: styles.innerHeading
  }, /*#__PURE__*/React.createElement(_StyledSpan2, {
    $_css2: hasUnderline ? styles.innerHeadingUnderline : undefined
  }, children));
};
export var HeroBanner = function HeroBanner(_ref2) {
  var backgroundColor = _ref2.backgroundColor,
    buttonBackgroundColor = _ref2.buttonBackgroundColor,
    _ref2$buttonDisabled = _ref2.buttonDisabled,
    buttonDisabled = _ref2$buttonDisabled === void 0 ? false : _ref2$buttonDisabled,
    buttonHref = _ref2.buttonHref,
    buttonText = _ref2.buttonText,
    _ref2$buttonTextColor = _ref2.buttonTextColorMode,
    buttonTextColorMode = _ref2$buttonTextColor === void 0 ? 'light' : _ref2$buttonTextColor,
    copy = _ref2.copy,
    headingIsPageTitle = _ref2.headingIsPageTitle,
    headingLine1 = _ref2.headingLine1,
    headingLine2 = _ref2.headingLine2,
    headingUnderlineColor = _ref2.headingUnderlineColor,
    imageAlt = _ref2.imageAlt,
    imageHeight = _ref2.imageHeight,
    imageLinkHref = _ref2.imageLinkHref,
    imageWidth = _ref2.imageWidth,
    images = _ref2.images,
    lazyImages = _ref2.lazyImages,
    onButtonClick = _ref2.onButtonClick,
    onImageLinkClick = _ref2.onImageLinkClick,
    onLinkClick = _ref2.onLinkClick,
    _ref2$onVisible = _ref2.onVisible,
    onVisible = _ref2$onVisible === void 0 ? function () {} : _ref2$onVisible,
    subHeading = _ref2.subHeading,
    textColorMode = _ref2.textColorMode;
  var _useVisibilityObserve = useVisibilityObserver(function () {
      return onVisible();
    }),
    observedElementRef = _useVisibilityObserve.observedElementRef;
  var hasUnderline = !!headingUnderlineColor;
  var removeImageLinkFromTabIndex = imageLinkHref === buttonHref;
  var commonButtonProps = {
    customBackgroundColor: buttonBackgroundColor,
    onClick: onButtonClick,
    textColorMode: buttonTextColorMode
  };
  var handleTextClick = function handleTextClick(e) {
    if (onLinkClick && getAnchorElementFromEvent(e)) {
      onLinkClick(e);
    }
  };
  var Image = function Image() {
    return /*#__PURE__*/React.createElement(FloatingBannerImage, {
      imageAlt: imageAlt,
      imageHeight: imageHeight,
      imageWidth: imageWidth,
      images: images,
      lazyImages: lazyImages,
      offset: "top"
    });
  };
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    ref: observedElementRef,
    $_css3: styles.topOffsetImageMarginContainer
  }, /*#__PURE__*/React.createElement(Banner, {
    backgroundColor: backgroundColor
  }, /*#__PURE__*/React.createElement(_StyledDiv2, {
    $_css4: styles.container
  }, imageLinkHref ? /*#__PURE__*/React.createElement(_StyledA, _extends({
    href: imageLinkHref,
    onClick: onImageLinkClick
  }, removeImageLinkFromTabIndex ? {
    tabIndex: -1
  } : {}, {
    $_css5: styles.imageWrapper
  }), /*#__PURE__*/React.createElement(Image, null)) : /*#__PURE__*/React.createElement(_StyledDiv3, {
    $_css6: styles.imageWrapper
  }, /*#__PURE__*/React.createElement(Image, null)), /*#__PURE__*/React.createElement(_StyledDiv4, {
    $_css7: styles.content
  }, /*#__PURE__*/React.createElement(_StyledDiv5, {
    $_css8: textColorMode === 'light' ? styles.lightTextContent : styles.darkTextContent
  }, /*#__PURE__*/React.createElement(_StyledHeading, {
    level: headingIsPageTitle ? 1 : 2,
    style: {
      '--underlineColor': headingUnderlineColor
    },
    $_css9: [styles.heading, buttonText ? styles.headingWithButton : styles.headingWithoutButton]
  }, /*#__PURE__*/React.createElement(HeadingInner, {
    hasUnderline: hasUnderline
  }, headingLine1), headingLine2 && /*#__PURE__*/React.createElement(HeadingInner, {
    hasUnderline: hasUnderline
  }, headingLine2)), subHeading &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
  React.createElement(_StyledDiv6, {
    onClick: handleTextClick,
    $_css10: [styles.subHeading, buttonText ? styles.subHeadingWithButton : styles.subHeadingWithoutButton]
  }, subHeading), copy &&
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
  React.createElement(_StyledDiv7, {
    onClick: handleTextClick,
    $_css11: styles.copy
  }, copy)), buttonText && /*#__PURE__*/React.createElement(_StyledDiv8, {
    $_css12: styles.buttonContainer
  }, buttonHref ? /*#__PURE__*/React.createElement(SolidButtonLink, _extends({}, commonButtonProps, {
    href: buttonHref
  }), buttonText) : /*#__PURE__*/React.createElement(SolidButton, _extends({}, commonButtonProps, {
    disabled: buttonDisabled
  }), buttonText))))));
};
var _StyledSpan = _styled("span")(_templateObject || (_templateObject = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css;
});
var _StyledSpan2 = _styled2("span")(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css2;
});
var _StyledDiv = _styled3("div")(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css3;
});
var _StyledDiv2 = _styled4("div")(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css4;
});
var _StyledA = _styled5("a")(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css5;
});
var _StyledDiv3 = _styled6("div")(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css6;
});
var _StyledDiv4 = _styled7("div")(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css7;
});
var _StyledDiv5 = _styled8("div")(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css8;
});
var _StyledHeading = _styled9(Heading)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css9;
});
var _StyledDiv6 = _styled10("div")(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css10;
});
var _StyledDiv7 = _styled11("div")(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["", ""])), function (p) {
  return p.$_css11;
});
var _StyledDiv8 = /*#__PURE__*/_styled12("div").withConfig({
  displayName: "HeroBanner___StyledDiv8",
  componentId: "sc-m53q2p-0"
})(["", ""], function (p) {
  return p.$_css12;
});